import React from 'react';
import { connect } from 'react-redux';
import { getCMSObject, TeleScript } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';

const PrivacyPolicyPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.privacyPolicy.pageInfo.pageTitle'),
        className: 'privacy',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='static-content'>
                <TeleScript
                    line={getCMSObject('data.microsite.general.privacyPolicy.contentHTML')}
                    replace={{
                        '%PROMOTION_URL%': config?.config?.appUrl ?? '/',
                    }}
                />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyPage);
